import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { InputContainer } from '../PrrRefund.styles';

const RefundAmountSelection = ({ options = [], register }) => (
  <InputContainer>
    {options.map(({ value, label, isExecutiveDecision = false }) => (
      <div key={label}>
        <label htmlFor={`${value}-percent`}>
          <input
            id={`${value}-percent`}
            data-cy={`${value}-percent`}
            type="radio"
            {...register('refundPercentage', { required: true })}
            value={String(value)}
          />
          <FormattedMessage
            id="prrRefund.mins"
            defaultMessage="{percentage} mins"
            values={{
              percentage: label
            }}
          />
          {isExecutiveDecision ? (
            <>
              {' '}
              - <FormattedMessage id="prrRefund.executiveDecision" />
            </>
          ) : (
            ''
          )}
        </label>
      </div>
    ))}
  </InputContainer>
);

RefundAmountSelection.displayName = 'RefundAmountSelection';

RefundAmountSelection.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.number,
      label: PropTypes.string
    })
  ),
  register: PropTypes.func.isRequired
};

export default RefundAmountSelection;
